import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const RootProviders = lazy(() => import('@app/components/AppProviders'))
const FindReplaceInfoBox = lazy(() => import('.'))

class FindReplaceInfoBoxComponent extends ReactWebComponent {
	override render() {
		return (
			<RootProviders>
				<FindReplaceInfoBox />
			</RootProviders>
		)
	}
}

customElements.define('find-replace-info-box', FindReplaceInfoBoxComponent)
